// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1FShd","clinicsSelect":"TableHeading_clinicsSelect__3efPW"};